











































































import moment from "moment";
import { EmployeApi } from "../../api/EmployeApi";

export default {
    name: "PlanningTablePreview",
    props: {
        employeId: Number,
    },
    data() {
        return {
            EmployeApi: new EmployeApi(),
            workingHours: {},
            plannings: {},
            dateRange: {
                start: moment().startOf("week").format("YYYY-MM-DD"),
                end: moment()
                    .startOf("week")
                    .add(4, "week")
                    .format("YYYY-MM-DD"),
            },
            dateRangeTable: {},
            datepickerAttributes: [
                {
                    key: "today",
                    dot: true,
                    dates: new Date(),
                },
            ],
        };
    },
    methods: {
        getPlannings() {
            let self = this;
            // Working Hours
            self.workingHours = {};
            let startDate = moment(self.dateRange.start);
            let endDate = moment(self.dateRange.end);
            while (startDate.isSameOrBefore(endDate)) {
                let date = startDate.clone();
                self.EmployeApi.getPlanningByDate(
                    self.employeId,
                    date.format("YYYY-MM-DD")
                ).then(function (planning) {
                    self.workingHours[date.format("YYYY-MM-DD")] = _.filter(
                        planning.planning_working_hours,
                        function (wh) {
                            return wh.jour === date.day();
                        }
                    );
                });
                startDate.add(1, "day");
            }
            // Plannings
            self.plannings = {};
            _.each(self.weeks, function (week) {
                self.EmployeApi.getPlanningByDate(
                    self.employeId,
                    _.first(self.dateRangeTable[week])
                ).then(function (planning) {
                    self.plannings[week] = planning;
                    setTimeout(function () {
                        self.$forceUpdate();
                    }, 500);
                });
            });
        },
        // UI
        planningId(week) {
            let self = this;
            if (_.has(self.plannings, week)) {
                return self.plannings[week].planning_id;
            }
            return "";
        },
        shortDate(date) {
            return moment(date).format("DD-MMM");
        },
        weekNumber(week) {
            return _.split(week, "-")[1];
        },
    },
    computed: {
        weeks() {
            return _.keys(this.dateRangeTable);
        },
    },
    watch: {
        dateRange: {
            immediate: true,
            deep: true,
            handler: function (newVal, oldVal) {
                let self = this;
                self.dateRangeTable = {};
                let startDate = moment(self.dateRange.start).startOf("week");
                let endDate = moment(self.dateRange.end).endOf("week");
                while (startDate.isSameOrBefore(endDate)) {
                    let weekNum = startDate.format("YYYY-WW");
                    if (!_.has(self.dateRangeTable, weekNum)) {
                        self.dateRangeTable[weekNum] = [];
                    }
                    self.dateRangeTable[weekNum].push(
                        startDate.format("YYYY-MM-DD")
                    );
                    startDate.add(1, "day");
                }
                self.getPlannings();
            },
        },
    },
};
